import React from 'react';
import Header from './components/header/Header';
import MainSection from './components/mainSection/MainSection';
import Summary from './components/summary/Summary';
import Experience from './components/experience/Experience';
import SelectedWork from './components/selectedWork/SelectedWork';
import ProjectSection from './components/projectSection/ProjectSection';
import Skills from './components/skills/Skills';
import Contact from './components/contact/Contact';
import './App.css';

function App() {
  return (
    <div className="site-shell">
      <Header />
      <MainSection />
      <main>
        <Summary />
        <Experience />
        <SelectedWork />
        <ProjectSection />
        <Skills />
        <Contact />
      </main>
    </div>
  );
}

export default App;
